/* eslint-disable no-restricted-globals */
import React, { useState } from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import { AccordionItem } from "../main/AccordionItem/AccordionItem";
import { FaSearch } from "react-icons/fa";

const FaqSection = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const faqData = [
    {
      header: "What is HighTable?",
      text: "HighTable is a mobile app that connects people based on shared interests and facilitates offline meetups, allowing users to build meaningful relationships and engage in activities they enjoy.",
    },
    {
      header: "How does HighTable work?",
      text: "HighTable matches users with similar interests and suggests meetups or events where they can connect in person. Users can browse interest categories and attend scheduled events.",
    },
    {
      header: "Who can use HighTable?",
      text: "HighTable is designed for anyone looking to connect with others who share similar interests. Whether you’re new to an area, looking to make new friends, or wanting to engage in your favorite activities with like-minded individuals, HighTable is for you. Users must be at least 18 years old to join.",
    },
    {
      header: "How do I sign up for HighTable?",
      text: "Download the HighTable app from the App Store or Google Play Store, then sign up using your email address, phone number, or social media account. Complete your profile by adding your interests and a brief bio.",
    },
    {
      header: "Is HighTable free to use?",
      text: "Yes, HighTable offers a free version with all the features.",
    },
    {
      header: "What information do I need to provide?",
      text: "You’ll need to provide your name, email address or phone number, and create a password during registration. To enhance your experience, we recommend adding a profile picture, a short bio, and your interests.",
    },
    {
      header: "How do I find people with similar interests?",
      text: "HighTable uses your interest tags to suggest matches with other users who share similar interests. You can also browse through interest categories and join tables that align with your hobbies and passions.",
    },
    {
      header: "How do I join a table?",
      text: "Browse the Table section in the app, where you'll find a list of upcoming meetups and events. Click on an event to see the details and RSVP if you’re interested in attending.",
    },
    {
      header: "Can I create my own events?",
      text: "Yes, users can create their own events. Go to the Create Event section, provide the necessary details such as date, time, location, and description, and invite others who share your interests.",
    },
    {
      header: "How does HighTable ensure my safety?",
      text: "HighTable prioritizes your safety by allowing users to report inappropriate behavior and providing detailed event information. We recommend meeting in public places and informing a friend or family member of your plans.",
    },
    {
      header: "How does HighTable protect my privacy?",
      text: "Your privacy is important to us. HighTable does not share your personal information with third parties without your consent. You can adjust your privacy settings in the app to control what information is visible to other users.",
    },
    {
      header: "I’m having trouble with the app. What should I do?",
      text: "First, try restarting the app and ensuring you have the latest version installed. If the issue persists, contact our customer support through the Help section in the app or email us at support@hightable.ai.",
    },
    {
      header: "How do I report a bug or suggest a feature?",
      text: "You can report bugs or suggest features by going to the Feedback section in the app. We value your input and strive to improve your experience on HighTable.",
    },
    {
      header: "How do I edit my profile?",
      text: "Go to the Profile section in the app, where you can edit your bio, update your interests, and change your profile picture.",
    },
    {
      header: "How do I delete my HighTable account?",
      text: "If you wish to delete your account, go to Settings, select Account, and choose Delete Account. Follow the prompts to confirm the deletion.",
    },
  ];

  const filteredFaqs = faqData.filter(
    (faq) =>
      faq.header.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.text.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Head />
      <Header />
      <section className="relative z-20  px-[24px] overflow-hidden bg-white pb-12 dark-bg-dark lg:pb-[90px] ">
        <div className="container mx-auto">
          <div className="flex flex-wrap -mx-4">
            {/* Left Side Section */}
            <div className="w-full lg:w-1/2 px-4">
              <div className="mb-6">
                <h2 className="mb-4 text-3xl font-bold text-gray-800 dark-text-white sm:text-[40px]/[48px]">
                  FAQ's
                </h2>
                <p className="text-base text-gray-500 dark-text-dark-6">
                  We are not perfect and we strive to improve ourselves too.
                  Here is a list of possible queries you might have. If you need
                  more information or have suggestions, email us at{" "}
                  <strong>
                    <a href="mailto:support@hightable.ai">
                      support@hightable.ai
                    </a>
                  </strong>
                </p>
              </div>
              <div className="relative mb-8">
                <input
                  type="text"
                  placeholder="Search questions..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full py-5 pl-20 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:none "
                />
                <FaSearch
                  className="absolute top-2 left-3 bg-[#e2b862] rounded-full p-3  text-white"
                  size={40}
                />
              </div>
              <div>
                <img
                  className="h-80 hidden sm:inline"
                  src="../../../images/faq.svg"
                />
              </div>
            </div>

            {/* Right Side Section */}
            <div className="w-full lg:w-1/2 px-4  h-[80vh] overflow-y-scroll">
              {filteredFaqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  header={faq.header}
                  text={faq.text}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqSection;
